import { Component, OnInit, Input, Output, OnDestroy, AfterViewInit, ViewChild, ElementRef, inject } from "@angular/core";
import { TaxReturnsResolver } from "../../tax-returns/tax-returns-resolver";
import { EventEmitter } from "@angular/core";
import { ITaxReturn } from "../../tax-returns/tax-return/model/i-tax-return";
import { DmsStats } from "../../tax-returns/tax-return/model/dms-stats";
import { ActivatedRoute, Router } from "@angular/router";
import { CleanElementSelectorPipe } from "../../../shared/pipes/clean-element-selector.pipe";
import { cloneDeep, isEqual } from "lodash-es";
import { combineLatest, Subscription ,  of } from "rxjs";
import { TaxReturnActionsComponent } from "../../../shared/components/tax-return-actions/tax-return-actions.component";
import { TaxReturnAction, TaxReturnStatus, TaxReturnStep } from "../../tax-returns/tax-return/model/status";
import { UserInfoService } from "../../user-info.service";
import { Client, Population, SmartFormType, SmartFormTypeService, TaxReturnFull,  TaxReturnService, } from "../../../../swaggerServices";
import { getActiveWarnings } from "../../tax-returns/get-full-tax-return";
import { TaxReturnLodgementCode } from "../../../../swaggerServices";
import { delay, mapTo, flatMap } from "rxjs/operators";
import { UntypedFormControl, Validators, AbstractControl } from "@angular/forms";
import moment from "moment";
import { ConfigStateService } from "../../config/config-state.service";
import { Tenant } from "../../../shared/types/tenant.enum";
import { IAssignee } from "../../../shared/types/assignee";
import { getQuestionnaireType } from "../../../shared/util/questionnaire-type.util";
import { TaxReturnTypeSubTypeService } from "../../../shared/util/tax-return-type-subtype.service";
import { TypeSubtypeLookup } from "../../../shared/util/tax-return-type-subtype";
import { BaseURLService } from "../../../shared/util/baseUrl.service";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { TranslocoService } from "@jsverse/transloco";
import { RunCalcsService } from "../../../shared/services/run-calcs.service";
import { MatDialog } from "@angular/material/dialog";
import { TemplateGenerationSelectionComponent } from "../../../shared/components/tax-return-actions/template-generation-selection/template-generation-selection.component";

declare const $: any;

const dateFormat = 'DD/MM/YYYY';

const dateValidator = (control: AbstractControl): { [key: string]: any } | null => {
  const regex = /^(0?[1-9]|[12][0-9]|3[01])[\/](?:(0?[1-9]|1[012])[\/][0-9]{4})$/;
  const isFormatValid = regex.test(control.value);
  const isBeforeTomorrow = moment(control.value, dateFormat).isBefore(moment());
  return isFormatValid && isBeforeTomorrow ? null : { 'dateValue': { value: control.value } };
};

@Component({
    selector: 'app-tax-return-sidebar',
    templateUrl: './tax-return-sidebar.component.html',
    styleUrls: ['./tax-return-sidebar.component.scss'],
    standalone: false
})
export class TaxReturnSidebarComponent implements OnInit, OnDestroy, AfterViewInit {

  taxReturn: ITaxReturn;
  // client: Client;
  @Output() collapseSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  fragment: string;
  subscriptions: Subscription[] = [];
  @ViewChild(TaxReturnActionsComponent) taxReturnActionsComponent: TaxReturnActionsComponent;
  refreshing: boolean = false;
  @ViewChild('packagePathModal') packagePathModal: ElementRef;
  docshareId: string; // form ctrl
  @ViewChild('docshareRootFolderModal') docshareRootFolderModal: ElementRef;
  atlasCirDate: UntypedFormControl; // form ctrl
  atlasCirDateFormat = dateFormat;
  @ViewChild('attachmentsModal') attachmentsModal: ElementRef;
  @ViewChild('atlasCirModal') atlasCirModal: ElementRef;
  @ViewChild('lodgementCodeModal') lodgementCodeModal: ElementRef;
  @ViewChild('cwpModal') cwpModal: ElementRef;
  @ViewChild('calcResultsModal') calcResultsModal: ElementRef;
  lodgementCode: string; // form ctrl
  isGeneratingDraftPackage: boolean;
  isUpdatingAttachments: boolean = false;
  @ViewChild('notesModal') notesModalEl: ElementRef;
  assigneeForNotes: IAssignee;
  tenants: any;
  taxReturnForNotes: ITaxReturn;
  loadingDocshareFolders: boolean = false;
  dmsStats: DmsStats;
  processingCwp: boolean = true;
  cwpMergedSuccess: boolean = false;
  checkGenerationCompleteSub?: Subscription = null;
  visibleAction: String;
  taxReturnPhase: string = '';
  draftGenerateLinkFirst: boolean = true;
  cirFullName: boolean = false;
  labelGenerateDraft: boolean = true;
  allowUpdateAttachments: boolean = false;
  useFileSystemStorage: boolean = false;
  calcsLastRunDate: string;
  client: Client;
  population: Population;
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  yearLabel: string;
  smartFormTypes: SmartFormType[];
  isSmartFormsEnabled: boolean;
  isRunningCalcs: boolean = false;
  isAdmin: boolean = false;
  calcResultsSummary: string[] = [];
  calcFailures: string[] = [];
  calcDebug: string[] = [];
  showCalcDebug: boolean = false;

  private dialog = inject(MatDialog);

  questionnaireTypeName: string;
  constructor(private baseUrl: BaseURLService,
    private taxReturnsResolver: TaxReturnsResolver,
    private taxReturnService: TaxReturnService,
    private activatedRoute: ActivatedRoute,
    private cleanElementSelectorPipe: CleanElementSelectorPipe,
    private router: Router,
    public userInfo: UserInfoService,
    public config: ConfigStateService,
    private taxReturnTypeSubTypeService: TaxReturnTypeSubTypeService,
    private translocoService: TranslocoService,
    private smartFormTypeService: SmartFormTypeService,
    private runCalcsService: RunCalcsService
  ) {}

  // collapse sidebar until data is fetched
  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
        if (config.tenant === Tenant.CN || config.tenant === Tenant.HK) {
          this.draftGenerateLinkFirst = false;
          this.cirFullName = true;
          this.labelGenerateDraft = false;
        }
        this.useFileSystemStorage = this.config.featureFlags.autoGenerateClientFolder;
      })
    );
    this.atlasCirDate = new UntypedFormControl("", {
      validators: [
        Validators.required,
        dateValidator,
      ],
    });
    this.collapseSidebar.emit(true);
    this.tenants = Tenant;

    this.subscriptions.push(this.taxReturnsResolver.getTaxReturnObs().subscribe((data: ITaxReturn) => {
      this.refreshing = false;

      this.taxReturn = cloneDeep(data);
      const population = this.taxReturn.assignee.populations.find(p => p.id === this.taxReturn.populationId)
      this.population = population;
      this.client = population ? population.client : undefined;
      this.startPollingForGenerationComplete();
      this.atlasCirDate.setValue(this.taxReturn.atlasCirDate);
      if (this.config.tenant === this.tenants.SG) {
        this.taxReturnService.dmsStats(this.taxReturn.id).subscribe((stats: DmsStats) => {
          this.dmsStats = stats;
        });
      }
      // generate anchor id refs
      if (this.taxReturn.categories && this.taxReturn.categories.length > 0) {
        this.taxReturn.categories.forEach((category, index) => {
          this.taxReturn.categories[index]['fragment'] = this.cleanElementSelectorPipe.transform(category.name.toLowerCase());
        });
      }
      this.taxReturnPhase = this.getTaxReturnPhase();
      this.questionnaireTypeName = getQuestionnaireType(this.taxReturn.questionnaireType);
      this.collapseSidebar.emit(false);
      this.taxReturnTypeSubTypeService.getAllTypesAndSubtypes().subscribe((result: TypeSubtypeLookup) => {
        const taxReturnType = result.types.get(data.taxReturnTypeId.toString());
        if (taxReturnType) this.taxReturn.taxReturnTypeKey = taxReturnType.alias;
      });
      this.allowUpdateAttachments = this.canUpdateAttachments();
      this.calcsLastRunDate = this.getCalcsLastRunDate();
      this.isSmartFormsEnabled=this.config.featureFlags.enableOneteamIntegration;
      if (this.isSmartFormsEnabled) {
        this.smartFormTypeService.getSmartFormTypesByTaxReturnTypeId(this.taxReturn.taxReturnTypeId).subscribe(({smartForms}) => {
          this.smartFormTypes = smartForms.filter((sf) => { return sf.year === this.taxReturn?.year });
        });
      }
    }));

    this.subscriptions.push(combineLatest([
      this.runCalcsService.isRunningCalcs,
      this.runCalcsService.calcResultsSummary,
      this.runCalcsService.calcFailures,
      this.runCalcsService.calcDebug,
      this.runCalcsService.showCalcDebug]).subscribe(
      ([isRunning, calcSummary, calcfail, calDebug, showCalDebug]) => {
        this.isRunningCalcs = isRunning,
          this.calcResultsSummary = calcSummary,
          this.calcFailures = calcfail,
          this.calcDebug = calDebug,
          this.showCalcDebug = showCalDebug
      }
    ))
    this.isAdmin = !!this.userInfo.isAdmin;
  }

  // enable active class on menu item by subscribing to current page anchor
  ngAfterViewInit() {
    this.subscriptions.push(this.activatedRoute.fragment.subscribe(fragment => {
      this.fragment = fragment;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    if (this.checkGenerationCompleteSub) {
      this.checkGenerationCompleteSub.unsubscribe();
    }
  }

  runCalcs() {
    this.runCalcsService.runCalcs(this.taxReturn.id, this.calcResultsModal, this.isAdmin, this.runAfterCalcsRunSuccess.bind(this));
  }

  clearCalcsResults() {
    this.runCalcsService.clearCalcsResults();
  }

  toggleCalcDebug() {
    this.runCalcsService.toggleCalcDebug();
  }

  runAfterCalcsRunSuccess() {
    this.refresh(this.taxReturn);
    return;
  }

  get disableRunCalcForLodgedTaxReturn(): boolean {
    return this.config.featureFlags.disableRunCalcForLodgedTaxReturn;
  }

  getCalcsLastRunDate() {
    let latestDate = moment('01/01/1970', dateFormat);
    const { lastCalcsRunDate } = this.taxReturn;
    if (lastCalcsRunDate) {
      latestDate = moment(lastCalcsRunDate);
    }
    return latestDate.isSame(moment('01/01/1970', dateFormat)) ? undefined : latestDate.format('DD/MM/YYYY HH:mm').toString();
  }

  doAction(action: TaxReturnAction) {
    this.taxReturnActionsComponent.doAction(this.taxReturn, action, this.getPopulationId(), true);
  }

  private getPopulationId() {
    if (!this.taxReturn || !this.taxReturn.assignee || !this.taxReturn.assignee.populations) {
      return null;
    }
    let populationId = null;
    this.taxReturn.assignee.populations.forEach(pop => {
      if (pop.year === this.taxReturn.year) {
        populationId = pop.id;
      }
    });
    return populationId;
  }

  refresh(taxReturn: ITaxReturn) {
    this.refreshing = true;
    this.taxReturnsResolver.refresh(taxReturn.id);
  }

  navigateAway(taxReturn: ITaxReturn) {
    const atlasId = String(taxReturn.atlasId);
    this.router.navigate(['/search'], { queryParams: { q: atlasId } });
  }

  openAllTaxReturnsPage(atlasId: number) {
    if (atlasId) {
      window.open(`${this.baseUrl.get()}/search?q=${atlasId}&year=All`);
    }
  }
  showActionButtons() {
    return this.taxReturn
      && this.taxReturn.snapshotId == null
      && (!this.taxReturn.assignedUser || this.taxReturn.assignedUser.id === this.userInfo.id)
      && this.taxReturn.assignee.status != 99
      && this.taxReturn.fullStatus.id !== 200;
  }

  readonly() {
    return !this.taxReturn
      || this.taxReturn.snapshotId != null
      || !this.taxReturn.assignedUser
      || this.taxReturn.assignedUser.id !== this.userInfo.id
      || this.taxReturn.assignee.status === 99
      || this.taxReturn.userIsReadOnly
      || this.taxReturn.fullStatus.readOnly;
  }

  showDocshareRootFolderModal() {
    $(this.docshareRootFolderModal.nativeElement).modal('show');
    if (!this.taxReturn.docshareRootFolder) {
      this.reloadDocshareFolders();
    }
  }

  updateAttachments() {
    this.isUpdatingAttachments = true;
    this.taxReturnService.updateAttachments(this.taxReturn.id).subscribe(tr => {
      this.isUpdatingAttachments = false;
      this.refresh(tr);
    }, () => {
      this.isUpdatingAttachments = false;
    });
  }

  reloadDocshareFolders() {
    this.loadingDocshareFolders = true;
    this.taxReturnService.loadDocshareFolders(this.taxReturn.id).subscribe(tr => {
      this.loadingDocshareFolders = false;
      this.taxReturn.docshareRootFolder = tr.docshareRootFolder;
      this.taxReturn.docshareTempFolder = tr.docshareTempFolder;
    }, () => {
      this.loadingDocshareFolders = false;
    });
  }

  templateSelectionModalAction() {
    const dialogRef = this.dialog.open(TemplateGenerationSelectionComponent, {
      width: '660px',
      data: {
        taxReturn: this.taxReturn,
        generateType: 'DRAFT'
      },
      autoFocus: false,
    });

    dialogRef.componentInstance.generateCompleted.subscribe((result) => {
      this.handleGenerateCompleted(result);
    });

    if (!this.config.featureFlags.selectPackageTemplates) {
      this.isGeneratingDraftPackage = true;
    }
  }

  showPackagePathModal() {
    $(this.packagePathModal.nativeElement).modal().modal('show');
    if (!this.taxReturn.docshareTempFolder) {
      this.reloadDocshareFolders();
    }
  }

  onClickFolderLink(folderType: string) {
    this.router.navigate(['tax-returns', this.taxReturn?.id, 'documents'], { queryParams: { folder: folderType }});
  }

  showAttachmentsModal() {
    $(this.attachmentsModal.nativeElement).modal('show');
  }

  showAtlasCirModal() {
    $(this.atlasCirModal.nativeElement).modal('show');
  }

  saveAtlasCirDate() {
    // normalize the date format e.g. 4/12/2019 becomes 04/12/2019
    const d = moment(this.atlasCirDate.value, dateFormat).format(dateFormat);
    this.atlasCirDate.setValue(d);
    this.taxReturnService.updateAtlasCirDate(this.taxReturn.id,{ atlasCirDate: d }).subscribe(tr => {
      this.taxReturn.atlasCirDate = tr.atlasCirDate;
      this.atlasCirDate.setValue(tr.atlasCirDate);
    });
  }

  showLodgementCodeModal() {
    this.lodgementCode = this.taxReturn.lodgementCode;
    $(this.lodgementCodeModal.nativeElement).modal('show');
  }

  saveLodgementCode() {
    this.taxReturnService.updateLodgementCode(
      this.taxReturn.id, { lodgementCode: this.lodgementCode }).subscribe((r: TaxReturnLodgementCode) => this.taxReturn.lodgementCode = r.code);
  }

  isLodged() {
    return isEqual(this.taxReturn.fullStatus.step, TaxReturnStep.LODGED);
  }

  isPrePrepStatus() {
    return this.taxReturn.status === TaxReturnStatus.PRE_PREPARATION.id;
  }

  // get total active warnings count for a category or for all categories
  getWarningsCount(category?) {
    let count = 0;
    (category ? [category] : this.taxReturn.categories).forEach(c =>
      c.subcategories.forEach(sc =>
        count += getActiveWarnings(this.taxReturn, sc)));
    return count;
  }

  canGenerateDraftPackage() {
    return !isEqual(this.taxReturn.fullStatus.step, TaxReturnStep.QUESTIONNAIRE_OUTSTANDING)
      && !isEqual(this.taxReturn.fullStatus.step, TaxReturnStep.LODGED)
      && this.showActionButtons() && !this.readonly();
  }

  canUpdateAttachments() {
    return this.config.featureFlags.allowAutoDocLink
      && !isEqual(this.taxReturn.fullStatus.step, TaxReturnStep.LODGED)
      && this.showActionButtons() && !this.readonly();
  }

  getFolderDisplayName() {
    if (this.config.tenant === Tenant.AU || this.config.tenant === Tenant.ESS || this.config.tenant === Tenant.SG) {
      return "Taxpayer DocShare Folder";
    }
    if (this.config.tenant === Tenant.CN || this.config.tenant === Tenant.HK) {
      return "Individual’s cnDocs Folder";
    }
    return "Taxpayer Folder";
  }

  showNotes() {
    this.assigneeForNotes = this.taxReturn.assignee;
    this.taxReturnForNotes = this.taxReturn;
    $(this.notesModalEl.nativeElement).modal({
      autofocus: false
    }).modal("show");
  }

  handleGenerateCompleted(generateSuccess: boolean) {
    if (generateSuccess) {
      this.startPollingForGenerationComplete();
    }
    if (!this.config.featureFlags.selectPackageTemplates) {
      this.isGeneratingDraftPackage = false;
    }
  }
  startPollingForGenerationComplete() {
    if (this.taxReturn && !this.taxReturn.generateRobotQueueItemId) {
      return;
    }
    if (this.checkGenerationCompleteSub) {
      return; // already polling
    }
    this.checkGenerationCompleteSub = of<TaxReturnFull>({})
      .pipe(
        delay(12000),
        flatMap(() => this.taxReturnService.getTaxReturnById(this.taxReturn.id))
      )
      .subscribe(tr => {
        this.checkGenerationCompleteSub.unsubscribe();
        this.checkGenerationCompleteSub = null;
        if (tr.id === this.taxReturn.id) {
          this.taxReturn.generateRobotQueueItemId = tr.generateRobotQueueItemId;
          if (tr.generateRobotQueueItemId) {
            this.startPollingForGenerationComplete();
          }
        }
      }, () => {
        this.checkGenerationCompleteSub.unsubscribe();
        this.checkGenerationCompleteSub = null;
        this.startPollingForGenerationComplete();
      });
  }

  mergeCwp() {
    this.processingCwp = true;
    this.cwpMergedSuccess = false;
    $(this.cwpModal.nativeElement).modal({ closable: false }).modal('show');
    this.taxReturnService.manageCwp(this.taxReturn.id).subscribe(() => {
      this.dmsStats.cwpFilesCount = 0;
      this.processingCwp = false;
      this.cwpMergedSuccess = true;
    }, e => {
      this.processingCwp = false;
      this.cwpMergedSuccess = false;
    });
  }

  private getTaxReturnPhase() {
    let taxReturnPhase = '';
    if (this.config.featureFlags.amendmentRevisionCount) {
      if (this.taxReturn.revisionCount > 0) {
        taxReturnPhase += `Revision #${this.taxReturn.revisionCount} <br>`;
      }
      if (this.taxReturn.amendmentCount > 0) {
        taxReturnPhase += `Amendment #${this.taxReturn.amendmentCount}`;
      }
      if (!taxReturnPhase) {
        taxReturnPhase = 'Original';
      }
    } else {
      taxReturnPhase = this.taxReturn.fullStatus.phase.name;
    }
    return taxReturnPhase;
  }

  getLinkUploadSource() {
    if (this.taxReturn.enableSourceFileListUpload) {
      return [this.uiConfig?.config?.taxReturnAliasPath, this.taxReturn?.id, 'dynamic-sources'];
    } else {
      return [this.uiConfig?.config?.taxReturnAliasPath, this.taxReturn?.id, 'dynamic-sources-dropdown'];
    }
  }
}
